import { render, staticRenderFns } from "./BlockTimeScale.vue?vue&type=template&id=4f193da4&"
import script from "./BlockTimeScale.vue?vue&type=script&lang=js&"
export * from "./BlockTimeScale.vue?vue&type=script&lang=js&"
import style0 from "./BlockTimeScale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports